import React from 'react';
import { graphql } from 'gatsby';
import useStoryblok from '~/utils/storyblok-service';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~/components/Layout';
import Seo from '~/components/SEO';
import DynamicComponent from '~/components/DynamicComponent';
import TextCard from '~/components/Dynamic/TextCard';
import Image from '~/components/Dynamic/Image';
import TwoColumns from '~/components/TwoColumns';

const EnterprisePage = ({ data, location, pageContext }) => {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story.content;

  const hero = content?.hero[0];
  const components = content?.body?.map((blok) => <section key={blok._uid} className="my-20 md:my-28"><DynamicComponent blok={blok} /></section>);
  return (
    <Layout locale={pageContext.locale}>
      <Seo {...content?.seo} lang={story.lang} pageContext={pageContext} />
      {hero && (
        <section className="my-16 md:my-28">
          <div className="container">
            <TwoColumns
              text={<TextCard blok={hero.textCard[0]} />}
              image={
                <div className="relative">
                  <StaticImage src={'../assets/images/enterprise-bg.jpg'} alt="Hero Background" loading="eager" />
                  <div className="absolute inset-0 flex flex-col items-center justify-center p-2 md:p-8">
                    <div className="w-full">
                      <Image blok={hero.asset[0]} />
                    </div>
                  </div>
                </div>
              }
            />
          </div>
        </section>
      )}

      {components}
    </Layout>
  );
};

export default EnterprisePage;

export const query = graphql`
  query enterpriseQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
